import api from "../../../services/api";

export const handleAccountPlanDownloadBtn = async (accountCode, clientCode) => {
    try {
        const formData = new FormData();
        formData.append("account_code", accountCode);
        formData.append("client_code", clientCode);

        const response = await api.post(
            "/accounts/downloadAccountPlan",
            formData,
            {
                responseType: 'blob', // Important for file downloads
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        );

        // Get filename from response headers if available
        const contentDisposition = response.headers['content-disposition'];
        const filename = contentDisposition 
            ? contentDisposition.split('filename=')[1]
            : 'account_plan.xlsx';

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 100);

    } catch (error) {
        console.error("Download failed:", error);
        // You might want to add user feedback here (e.g., toast notification)
    }
};